(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.neuroApi = {}));
}(this, (function (exports) { 'use strict';

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  var defineProperty = _defineProperty;

  function createCommonjsModule(fn, basedir, module) {
  	return module = {
  	  path: basedir,
  	  exports: {},
  	  require: function (path, base) {
        return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
      }
  	}, fn(module, module.exports), module.exports;
  }

  function commonjsRequire () {
  	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
  }

  var _typeof_1 = createCommonjsModule(function (module) {
    function _typeof(obj) {
      "@babel/helpers - typeof";

      if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
        module.exports = _typeof = function _typeof(obj) {
          return typeof obj;
        };
      } else {
        module.exports = _typeof = function _typeof(obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
      }
      return _typeof(obj);
    }
    module.exports = _typeof;
  });

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var classCallCheck = _classCallCheck;

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }
  var createClass = _createClass;

  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var CONTENT_DISPOSITION_ATTACHMENT = 'attachment';
  var FetchOptionsBuilder = /*#__PURE__*/function () {
    function FetchOptionsBuilder() {
      classCallCheck(this, FetchOptionsBuilder);
      this.charset = 'utf-8';
      this.method = 'GET';
      this.headers = null;
      this.contentType = null;
      this.contentDisposition = null;
      this.credentials = null;
    }
    createClass(FetchOptionsBuilder, [{
      key: "get",
      value: function get() {
        this.method = 'GET';
        return this;
      }
    }, {
      key: "post",
      value: function post() {
        this.method = 'POST';
        return this;
      }
    }, {
      key: "put",
      value: function put() {
        this.method = 'PUT';
        return this;
      }
    }, {
      key: "delete",
      value: function _delete() {
        this.method = 'DELETE';
        return this;
      }
    }, {
      key: "json",
      value: function json() {
        this.contentType = 'application/json';
        return this;
      }
    }, {
      key: "html",
      value: function html() {
        this.contentType = 'text/html';
        return this;
      }
    }, {
      key: "text",
      value: function text() {
        this.contentType = 'text/plain';
        return this;
      }
    }, {
      key: "noContentType",
      value: function noContentType() {
        this.contentType = null;
        return this;
      }
    }, {
      key: "sameOriginCredentials",
      value: function sameOriginCredentials() {
        this.credentials = 'same-origin';
        return this;
      }
    }, {
      key: "credentials",
      value: function credentials(creds) {
        this.credentials = creds;
        return this;
      }
    }, {
      key: "dispositionAttachement",
      value: function dispositionAttachement(fileName) {
        this.contentDisposition = {
          disposition: 'attachment',
          fileName: fileName
        };
        return this;
      }
    }, {
      key: "header",
      value: function header(name, value) {
        var headers = this.headers || {};
        if (name && value !== undefined) {
          headers[name] = value;
        }
        this.headers = headers;
        return this;
      }
    }, {
      key: "body",
      value: function body(bodyContent) {
        this.bodyContent = bodyContent;
        return this;
      }
    }, {
      key: "build",
      value: function build() {
        var opts = {
          method: this.method
        };

        // headers
        var headers = _objectSpread({}, this.headers || {});
        if (this.contentType) {
          headers['Content-Type'] = this.contentType;
        }
        if (this.contentDisposition) {
          switch (this.contentDisposition.disposition) {
            case CONTENT_DISPOSITION_ATTACHMENT:
              headers['Content-Disposition'] = this.contentDisposition.fileName ? "".concat(CONTENT_DISPOSITION_ATTACHMENT, "; filename=\"").concat(this.contentDisposition.fileName, "\"") : CONTENT_DISPOSITION_ATTACHMENT;
              break;
          }
        }
        opts.headers = headers;
        if (this.credentials) {
          opts.credentials = this.credentials;
        }
        if (this.bodyContent !== undefined && this.bodyContent !== null) {
          switch (_typeof_1(this.bodyContent)) {
            case 'object':
              opts.body = JSON.stringify(this.bodyContent);
              break;
            default:
              opts.body = this.bodyContent;
              break;
          }
        }
        return opts;
      }
    }]);
    return FetchOptionsBuilder;
  }();

  function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
  function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var X_REQUESTED_WITH = 'X-Requested-With';
  var XML_HTTP_REQUEST = 'XMLHttpRequest';
  var CONTENT_TYPE = {
    TEXT_PLAIN: 'text/plain',
    APPLICATION_JSON: 'application/json'
  };

  /**
   * If returned content type is application/json parses the JSON returned by a network request.
   * Returns response text otherwise.
   *
   * @param  {object} response A response from a network request
   *
   * @return {object}          The parsed JSON from the request
   */
  function parseJSON(response) {
    var responseType = response.headers.get('Content-Type');
    var isJSONResponse = (responseType && responseType.indexOf(CONTENT_TYPE.APPLICATION_JSON)) >= 0;
    if (response.status === 204 || response.status === 205) {
      return null;
    }
    return isJSONResponse ? response.json() : response.text();
  }

  /**
   * Checks if a network request came back fine, and throws an error if not
   *
   * @param  {object} response   A response from a network request
   *
   * @return {object|undefined} Returns either the response, or throws an error
   */
  function checkStatus(response) {
    if (response.status >= 200 && response.status < 300) {
      return response;
    }
    var error = new Error("".concat(response.status, " ").concat(response.statusText));
    error.response = response;
    throw error;
  }

  /**
   * Checks if provided content should be sent as JSON
   *
   * @param  {any} body             A request body
   * @param  {string} contentType   A HTTP content-type header value eg. 'application/json'
   *
   * @return {true|false} Returns true when contentType === 'application/json' or body is object and contentType is not defined
   */
  function isJSONContent(body, contentType) {
    var result = false;
    if (!contentType) {
      result = _typeof_1(body) === 'object';
    } else {
      result = contentType === CONTENT_TYPE.APPLICATION_JSON;
    }
    return result;
  }

  /**
   * Return body normalized to valid JSON format based on it's type
   *
   * @param  {any} body   A request body
   *
   * @return {any} Returns valid JSON body, eg. adds "" when body is string and is not enclosed with ""
   */
  function jsonizeBody(body) {
    var jsonBody = body;
    if (body && typeof body === 'string' && !(body.startsWith('"') && body.endsWith('"'))) {
      jsonBody = "\"".concat(body.replace(/"/g, '\\"'), "\"");
    }
    return jsonBody;
  }

  /**
   * Requests a URL, returning a promise
   *
   * @param  {string} url       The URL we want to request
   * @param  {object} [options] The options we want to pass to "fetch"
   *
   * @return {object}           The response data
   */
  function request(url, options) {
    return fetch(url, options).then(checkStatus).then(parseJSON);
  }

  /**
   * Requests a URL, returning a promise
   *
   * @param  {string} url       The URL we want to get
   *
   * @return {object}           The response data
   */
  function get(url, options) {
    var internalOpts = new FetchOptionsBuilder().get().sameOriginCredentials().header(X_REQUESTED_WITH, XML_HTTP_REQUEST).build();
    var opts = options ? _objectSpread$1(_objectSpread$1({}, internalOpts), options) : internalOpts;
    return fetch(url, opts).then(checkStatus).then(parseJSON);
  }

  /**
   * Requests a URL, returning a promise
   *
   * @param  {string} url       The URL we want to get
   *
   * @param  {string} fileName  The name of downloaded file
   *
   * @return {object}           The response data
   */
  function download(url, fileName, options) {
    var internalOpts = new FetchOptionsBuilder().get().sameOriginCredentials().header(X_REQUESTED_WITH, XML_HTTP_REQUEST).dispositionAttachement(fileName).build();
    var opts = options ? _objectSpread$1(_objectSpread$1({}, internalOpts), options) : internalOpts;
    return fetch(url, opts).then(checkStatus).then(parseJSON);
  }

  /**
   * Sends provided data with POST method to url
   *
   * @param  {string} url          The URL we want to post
   * @param  {object|string} body  sends json if body is of type object or plain text when body is string
   *
   * @return {object}           The response data
   */
  function post(url, body, contentType, options) {
    var isJSON = isJSONContent(body, contentType);
    var builder = new FetchOptionsBuilder().post().body(isJSON ? jsonizeBody(body) : body).header(X_REQUESTED_WITH, XML_HTTP_REQUEST).sameOriginCredentials();
    var internalOpts = isJSON ? builder.json().build() : builder.text().build();
    var opts = options ? _objectSpread$1(_objectSpread$1({}, internalOpts), options) : internalOpts;
    return fetch(url, opts).then(checkStatus).then(parseJSON);
  }

  /**
   * Sends provided data with PUT method to url
   *
   * @param  {string} url          The URL we want to put
   * @param  {object|string} body  sends json if body is of type object or plain text when body is string
   *
   * @return {object}           The response data
   */
  function put(url, body, contentType, options) {
    var isJSON = isJSONContent(body, contentType);
    var builder = new FetchOptionsBuilder().put().body(isJSON ? jsonizeBody(body) : body).header(X_REQUESTED_WITH, XML_HTTP_REQUEST).sameOriginCredentials();
    var internalOpts = isJSON ? builder.json().build() : builder.text().build();
    var opts = options ? _objectSpread$1(_objectSpread$1({}, internalOpts), options) : internalOpts;
    return fetch(url, opts).then(checkStatus).then(parseJSON);
  }

  /**
   * Sends DELETE request to url
   *
   * @param  {string} url       The URL we want to 'DELETE'
   *
   * @return {object}           The response data
   */
  function del(url, options) {
    var internalOpts = new FetchOptionsBuilder().delete().sameOriginCredentials().header(X_REQUESTED_WITH, XML_HTTP_REQUEST).build();
    var opts = options ? _objectSpread$1(_objectSpread$1({}, internalOpts), options) : internalOpts;
    return fetch(url, opts).then(checkStatus).then(parseJSON);
  }

  var DEFAULT_API_PATH = 'access';

  // SESSIONS
  var createSessions = function createSessions(accessApiUrl) {
    var SESSIONS_URL = "".concat(accessApiUrl, "/sessions/");
    var createSession = function createSession(account, password, namespace) {
      var body = namespace ? {
        account: account,
        password: password,
        namespace: namespace
      } : {
        account: account,
        password: password
      };
      return post(SESSIONS_URL, body);
    };
    var deleteSession = function deleteSession() {
      var sid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return del(sid ? "".concat(SESSIONS_URL).concat(sid) : SESSIONS_URL);
    };
    var sessions = {
      SESSIONS_URL: SESSIONS_URL,
      /**
       * Starts new user session with provided credentials.
       * @memberof AccessAPI.sessions
       * @param {string} [account] - account name
       * @param {string} [password] - password for given account
       * @param {string} [namespace] - namespace to log in with - optional - default namespace will be used if undefined
       * @returns {Promise} A promise to empty response, resolved on success and rejected on any HTTP or network error
       */
      create: createSession,
      /**
       * Same as `create`. Starts new user session with provided credentials.
       * @memberof AccessAPI.sessions
       * @returns {Promise} A promise to empty response, resolved on success and rejected on any HTTP or network error
       */
      login: createSession,
      /**
       * Ends session with given `sid`. If `sid` is not provided current session is ended.
       * @memberof AccessAPI.sessions
       * @param {string} [sid] - id of the session to end
       * @returns {Promise} A promise to empty response, resolved on success and rejected on any HTTP or network error
       */
      remove: deleteSession,
      /**
       * Same as `remove`.
       * @memberof AccessAPI.sessions
       * @param {string} [sid] - id of the session to end
       * @returns {Promise} A promise to empty response, resolved on success and rejected on any HTTP or network error
       */
      logout: deleteSession,
      /**
       * Gets list of active sessions
       * @memberof AccessAPI.sessions
       * @returns {Promise<Object>} A promise to list of active sessions
       */
      list: function list() {
        return get("".concat(SESSIONS_URL));
      },
      /**
       * Gets information about session with given `id`. If `id` is not provided current session info is returned.
       * @memberof AccessAPI.sessions
       * @param {string} [sid] - id of the session to get; defaults to `'current'`
       * @returns {Promise<Object>} A promise to session object as described in API documentation for `GET /api/access/sessions/<sid>` endpoint
       */
      get: function get$1() {
        var sid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'current';
        return get("".concat(SESSIONS_URL).concat(sid));
      }
    };
    return sessions;
  };

  // ACCOUNT SETTINGS
  var createSettings = function createSettings(accessApiUrl) {
    return {
      SETTINGS_URL: "".concat(accessApiUrl, "/settings/"),
      /**
       * Retrieves value of given user setting. If setting name is not provided object with all user settings is returned.
       * @memberof AccessAPI.settings
       * @param {string} settingName - name of the setting to get
       * @returns {Promise<any>} A promise to object with all user settings, or to single setting value if it's name has been specified. Returned value may be of any valid JSON type.
       */
      get: function get$1(settingName) {
        return get(settingName ? "".concat(this.SETTINGS_URL).concat(settingName) : "".concat(this.SETTINGS_URL));
      },
      /**
       * Sets value of given setting.
       * @memberof AccessAPI.settings
       * @param {string} name - name of the setting to set
       * @param {any} value - value of the setting to store under `name`. Accepts all valid JSON types.
       * @returns {Promise} A promise to empty response
       */
      set: function set(name, value) {
        return name ? post("".concat(this.SETTINGS_URL).concat(name), value, CONTENT_TYPE.APPLICATION_JSON) : null;
      },
      /**
       * Deleted setting with given name. Removes it from database.
       * @memberof AccessAPI.settings
       * @param {string} name - name of the setting to remove
       * @returns {Promise} A promise to empty response
       */
      unset: function unset(name) {
        return name ? del("".concat(this.SETTINGS_URL).concat(name)) : null;
      }
    };
  };

  // ACCOUNTS
  var createAccounts = function createAccounts(accessApiUrl) {
    return {
      ACCOUNTS_URL: "".concat(accessApiUrl, "/accounts"),
      /**
       * Gets list of user account names
       *
       * API call: `/api/access/accounts`
       * @memberof AccessAPI.accounts
       * @param {string|string[]} fields A list of field names te get from account records, if it is not specified only id is taken
       * @returns {Promise<string[]|Object[]>} if `fields` param is not defined returns array of account names (strings) and array of objects otherwise.
       */
      list: function list(fields) {
        var fieldStr = Array.isArray(fields) ? fields.join(',') : fields;
        return fieldStr ? get("".concat(this.ACCOUNTS_URL, "?fields=").concat(fieldStr)) : get(this.ACCOUNTS_URL);
      },
      /**
       * Retrieves information about given user account
       * @memberof AccessAPI.accounts
       * @param {string} accountName
       * @returns {Promise<Object>} A promise to account object as described in API documentation for `GET /api/access/accounts/<accountName>` endpoint
       */
      get: function get$1(accountName) {
        return get("".concat(this.ACCOUNTS_URL, "/").concat(accountName));
      },
      /**
       * Creates new user account
       * @memberof AccessAPI.accounts
       * @param {Object} account - user account object as described in API documentation
       * @returns {Promise} A promise to empty response.
       */
      create: function create(account) {
        return post(this.ACCOUNTS_URL, account);
      },
      /**
       * Modifies new user account
       * @memberof AccessAPI.accounts
       * @param {string} accountName - name of the account to update
       * @param {Object} updater - user account object with new values
       * @returns {Promise} A promise to empty response.
       */
      update: function update(accountName, updater) {
        return put("".concat(this.ACCOUNTS_URL, "/").concat(accountName), updater);
      },
      /**
       * Deletes user account with given name
       * @memberof AccessAPI.accounts
       * @param {string} accountName - name of the account to delete
       * @returns {Promise} A promise to empty response
       */
      delete: function _delete(accountName) {
        return del("".concat(this.ACCOUNTS_URL, "/").concat(accountName));
      }
    };
  };

  // GROUPS
  var createGroups = function createGroups(accessApiUrl) {
    return {
      GROUPS_URL: "".concat(accessApiUrl, "/groups"),
      /**
       * Gets list of permission group names
       *
       * @memberof AccessAPI.groups
       * @param {string|string[]} fields A list of field names te get from group records, if it is not specified only id is taken
       * @returns {Promise<string[]>} A promise to list of group names.
       */
      list: function list(fields) {
        var fieldStr = Array.isArray(fields) ? fields.join(',') : fields;
        return fieldStr ? get("".concat(this.GROUPS_URL, "?fields=").concat(fieldStr)) : get(this.GROUPS_URL);
      },
      /**
       * Retrieves information about given permission group
       * @memberof AccessAPI.groups
       * @param {string} groupName
       * @returns {Promise<Object>} A promise to group object as described in API documentation for `GET /api/access/groups/<groupName>` endpoint
       */
      get: function get$1(groupName) {
        return get("".concat(this.GROUPS_URL, "/").concat(groupName));
      },
      /**
       * Creates new permission group
       * @memberof AccessAPI.groups
       * @param {Object} group - permission group object as described in API documentation
       * @returns {Promise} A promise to empty response.
       */
      create: function create(group) {
        return post(this.GROUPS_URL, group);
      },
      /**
       * Modifies new permission group
       * @memberof AccessAPI.groups
       * @param {string} groupName - name of the group to update
       * @param {Object} updater - permission group object with new values
       * @returns {Promise} A promise to empty response.
       */
      update: function update(groupName, updater) {
        return put("".concat(this.GROUPS_URL, "/").concat(groupName), updater);
      },
      /**
       * Deletes permission group with given name
       * @memberof AccessAPI.groups
       * @param {string} groupName - name of the group to delete
       * @returns {Promise} A promise to empty response
       */
      delete: function _delete(groupName) {
        return del("".concat(this.GROUPS_URL, "/").concat(groupName));
      }
    };
  };

  // PERMISSIONS
  var createPermissions = function createPermissions(accessApiUrl) {
    return {
      PERMISSIONS_URL: "".concat(accessApiUrl, "/permissions/"),
      /**
       * Gets list of all API permission names
       * @memberof AccessAPI.permissions
       * @returns {Promise<string[]>} A promise to list of permission names.
       */
      list: function list() {
        return get(this.PERMISSIONS_URL);
      },
      /**
       * Gets details about single permission
       * @memberof AccessAPI.permissions
       * @param {string} permissionName
       * @returns {Promise<Object>} A promise to permission details.
       */
      get: function get$1(permissionName) {
        return get("".concat(this.PERMISSIONS_URL).concat(permissionName));
      }
    };
  };

  // ACTIVITY
  var createActivity = function createActivity(accessApiUrl) {
    return {
      ACTIVITY_URL: "".concat(accessApiUrl, "/activity"),
      /**
       * Gets list of all API users activities
       * @memberof AccessAPI.activity
       * @param {string} account - account name whose activities will be returned - when not provided activities for all accounts will be returned
       * @param {string} from - date (ISO8601 formact, UTC, no ms) of the oldest activity to return
       * @param {string} to - date (ISO8601 formact, UTC, no ms) of the newest activity to return
       * @param {string} count - number of activities to return (page size)
       * @returns {Promise<string[]>} A promise to list of user activities.
       */
      list: function list(account, from, to, count) {
        var path = [this.ACTIVITY_URL, account].filter(function (e) {
          return e;
        }).join('/');
        var params = {
          from: from,
          to: to,
          count: count
        };
        var queryString = Object.keys(params).sort().map(function (k) {
          return params[k] ? "".concat(k, "=").concat(params[k]) : '';
        }).filter(function (e) {
          return e;
        }).join('&');
        queryString = queryString ? "?".concat(queryString) : '';
        return get("".concat(path).concat(queryString));
      }
    };
  };

  /**
   * Creates new Access API client
   * @function
   * @param {string} baseApiUrl - base API url containing `/api` path, eg. `http://example.com/api`
   * @param {string} path - path storage API is available under, without leading slash, added to `baseApiUrl`. Defaults to `access` when not defined.
   * @returns {AccessAPI} new AccessAPI object
   */
  var createAccessAPI = function createAccessAPI(baseApiUrl) {
    var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_API_PATH;
    var ACCESS_URL = "".concat(baseApiUrl, "/").concat(path);
    /**
     * Access API client (`/api/access/*` endpoints)
     * @typedef {Object} AccessAPI
     * @property {Object} sessions - functions of Sessions module of AccessAPI
     * @property {Object} accounts - functions of Accounts module of AccessAPI
     * @property {Object} activity - functions of Activity module of AccessAPI
     * @property {Object} settings - functions of Account Settings module of AccessAPI
     * @property {Object} groups - functions of Groups module of AccessAPI
     * @property {Object} permissions - functions of Permissions module of AccessAPI
     */
    return {
      /**
       * @memberof AccessAPI
       */
      sessions: createSessions(ACCESS_URL),
      /**
       * @memberof AccessAPI
       */
      accounts: createAccounts(ACCESS_URL),
      /**
       * @memberof AccessAPI
       */
      activity: createActivity(ACCESS_URL),
      /**
       * @memberof AccessAPI
       */
      settings: createSettings(ACCESS_URL),
      /**
       * @memberof AccessAPI
       */
      groups: createGroups(ACCESS_URL),
      /**
       * @memberof AccessAPI
       */
      permissions: createPermissions(ACCESS_URL)
    };
  };

  /**
   * Creates object containing various common methods for service parameters management.
   * Used by other APIs - returned object is usually mounted at `params` property
   *
   * @function
   * @param {string} parentApiUrl - main url to given service endpoints, eg. `/api/status` for status service, `/api/config` for config service etc.
   * @returns {ServiceParametersAPI} new ServiceParametersAPI object
   */
  var createParameters = function createParameters(parentApiUrl) {
    var PARAMS_URL = "".concat(parentApiUrl, "/parameters");
    /**
     * ServiceParametersAPI object (`/api/<service_name>/parameters` endpoints)
     * @typedef {Object} ServiceParametersAPI
     * @property {function} set - sets parameter value
     * @property {function} get - gets parameter value
     * @property {function} getMany - gets values of many parameters in one request
     */
    return {
      PARAMS_URL: PARAMS_URL,
      /**
       * Sets value of given parameter
       * @memberof ServiceParametersAPI
       * @param {string} name - name of the parameter to set
       * @param {any} value - value to set
       * @param {Object} reqOptions
       * @returns {Promise<any>} - result of `POST /api/<service_name>/parameters/<name>`
       */
      set: function set(name, value, reqOptions) {
        return post("".concat(PARAMS_URL, "/").concat(name), value, undefined, reqOptions);
      },
      /**
       * Gets values of all parameters or value of one parameter with given name
       * @memberof ServiceParametersAPI
       * @param {string} name - name of the parameter to get
       * @param {Object} reqOptions
       * @returns {Promise<ServiceParameterResponse>} - promise resolved with ServiceParameterResponse object
       */
      get: function get$1(name, reqOptions) {
        return name ? get("".concat(PARAMS_URL, "/").concat(name), reqOptions) : get(PARAMS_URL, reqOptions);
      },
      /**
       * Gets values enumerated parameters
       * @memberof ServiceParametersAPI
       * @param {string[]} nameList - array of strings enumerating parameter names to get
       * @returns {Promise<ServiceParameterResponse[]>} - promise resolved with array of ServiceParameterResponse objects in the same order as param names array
       */
      getMany: function getMany() {
        var nameList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var allRequired = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var reqOptions = arguments.length > 2 ? arguments[2] : undefined;
        var promises = nameList.map(function (name) {
          return get("".concat(PARAMS_URL, "/").concat(name), reqOptions);
        });
        return allRequired ? Promise.all(promises) : Promise.allSettled(promises);
      }
    };
  };

  var DEFAULT_API_PATH$1 = 'config';

  /**
   * Creates new Config API client
   * @function
   * @param {string} baseApiUrl - base API url containing `/api` path, eg. `http://example.com/api`
   * @param {string} path - path storage API is available under, without leading slash, added to `baseApiUrl`. Defaults to `config` when not defined.
   * @returns {ConfigAPI} new ConfigAPI object
   */
  var createConfigAPI = function createConfigAPI(baseApiUrl) {
    var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_API_PATH$1;
    var CONFIG_URL = "".concat(baseApiUrl, "/").concat(path);
    /**
     * Config API client (`/api/config/*` endpoints)
     * @typedef {Object} ConfigAPI
     * @property {ServiceParametersAPI} params - functions for management of config service parameters
     */
    return {
      /**
       * @memberof ConfigAPI
       */
      params: createParameters(CONFIG_URL)
    };
  };

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  }
  var arrayLikeToArray = _arrayLikeToArray;

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return arrayLikeToArray(arr);
  }
  var arrayWithoutHoles = _arrayWithoutHoles;

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
  }
  var iterableToArray = _iterableToArray;

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
  }
  var unsupportedIterableToArray = _unsupportedIterableToArray;

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var nonIterableSpread = _nonIterableSpread;

  function _toConsumableArray(arr) {
    return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
  }
  var toConsumableArray = _toConsumableArray;

  var DEFAULT_API_PATH$2 = 'drones';
  var createItems = function createItems(dronesApiUrl) {
    var ITEMS_URL = "".concat(dronesApiUrl, "/items");
    return {
      ITEMS_URL: ITEMS_URL,
      /**
       * Returns informations about drones known to the system.
       * @memberof DronesAPI.items
       * @param {string[]} [fields] - names of fields to return for each terminal
       * @param {number} from - index of the first returned result (0-based)
       * @param {number} count - number of records to return
       * @param {Object} reqOptions
       * @returns {Promise<ListResponse>} if `fields` param is not defined returns array of event ids (strings) and array of objects otherwise.
       */
      list: function list(fields) {
        var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
        var reqOptions = arguments.length > 3 ? arguments[3] : undefined;
        var queryString = ["from=".concat(from), "count=".concat(count), fields && fields.length > 0 ? "fields=".concat(fields.join(',')) : null].filter(function (e) {
          return e;
        }).join('&');
        return get("".concat(ITEMS_URL).concat(queryString ? "?".concat(queryString) : ''), reqOptions);
      },
      /**
       * Returns object describing single drone with given id
       * @memberof DronesAPI.items
       * @param {string} id - drone id
       * @param {Object} reqOptions
       * @returns {Promise<Object>} A promise to drone object as described in API documentation for `GET /api/drones/items/<droneId>` endpoint
       */
      get: function get$1() {
        var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        var reqOptions = arguments.length > 2 ? arguments[2] : undefined;
        if (!id) {
          throw new Error('Drone id is required');
        }
        var pathElements = Array.isArray(path) ? path : [path];
        var url = [ITEMS_URL, id].concat(toConsumableArray(pathElements)).filter(function (e) {
          return e;
        }).join('/');
        return get(url, reqOptions);
      }
    };
  };

  /**
   * Creates new Drones API client
   * @function
   * @param {string} baseApiUrl - base API url containing `/api` path, eg. `http://example.com/api`
   * @param {string} path - path storage API is available under, without leading slash, added to `baseApiUrl`. Defaults to `drones` when not defined.
   * @returns {DronesAPI} new DronesAPI object
   */
  var createDronesAPI = function createDronesAPI(baseApiUrl) {
    var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_API_PATH$2;
    var DRONES_URL = "".concat(baseApiUrl, "/").concat(path);
    /**
     * Drones API client (`/api/drones/*` endpoints)
     * @typedef {Object} DronesAPI
     * @property {Object} items - object with functions on Items module of DronesAPI
     * @property {ServiceParametersAPI} params - functions for management of drones service parameters
     */
    return {
      DRONES_URL: DRONES_URL,
      /**
       * @memberof DronesAPI
       */
      items: createItems(DRONES_URL),
      /**
       * @memberof DronesAPI
       */
      params: createParameters(DRONES_URL)
    };
  };

  /**
   * Creates new General API client
   * @function
   * @param {string} baseApiUrl - base API url containing `/api` path, eg. `http://example.com/api`
   * @returns {GeneralAPI} new GeneralAPI object
   */
  var createGeneralAPI = function createGeneralAPI(baseApiUrl) {
    var GENERAL_URL = "".concat(baseApiUrl);
    /**
     * General API client
     * @typedef {Object} GeneralAPI
     */
    return {
      /**
       * @memberof GeneralAPI
       * @param {string|string[]} path - path of the object property to get, eg. ['foo', 'bar', 'baz'] for property 'foo.bar.baz'. If path is not specified, whole object will be returned.
       * @returns {Object} Promise to general info object
       */
      info: function info(path) {
        var pathElements = Array.isArray(path) ? path : [path];
        var url = ["".concat(GENERAL_URL, "/info")].concat(toConsumableArray(pathElements)).filter(function (e) {
          return e;
        }).join('/');
        return get(url);
      },
      /**
       * Retrieves whole status object, or it's selected element
       * @memberof GeneralAPI
       * @param {string|string[]} path - path of the object property to get, eg. ['foo', 'bar', 'baz'] for property 'foo.bar.baz'. If path is not specified, whole object will be returned.
       * @returns {Object} Promise to status object
       */
      status: function status(path) {
        var pathElements = Array.isArray(path) ? path : [path];
        var url = ["".concat(GENERAL_URL, "/status")].concat(toConsumableArray(pathElements)).filter(function (e) {
          return e;
        }).join('/');
        return get(url);
      }
    };
  };

  /**
   * List Response
   * @typedef {Object} ListResponse
   * @property {number} from - index of the first returned record (pagination)
   * @property {number} count - number of returned records
   * @property {number} total - total number of available records matching query
   * @property {string[]|object[]} items - results - array of identifiers (strings) or array of objects containing fields enumerated in `fields` query param
   */

  /**
   * Service Parameters Response
   * @typedef {Object} ServiceParameterResponse
   * @property {string} access - index of the first returned record (pagination)
   * @property {string} description - number of returned records
   * @property {string} name - total number of available records matching query
   * @property {object|array} value - results - array of identifiers (strings) or array of objects containing fields enumerated in `fields` query param
   */

  var DEFAULT_API_PATH$3 = 'locations';
  var createCountries = function createCountries(locationsApiUrl) {
    var COUNTRIES_URL = "".concat(locationsApiUrl, "/countries");
    return {
      COUNTRIES_URL: COUNTRIES_URL,
      /**
       * Returns object with locations data for all or given country
       * @memberof LocationsAPI.countries
       * @param {string} country - two letter country abbreviation (eg. pl, en, de itp.)
       * @param {string[]} path -
       * @param {string[]} conditions - list of filtering conditions in form ['field1/name:operator:value', ...]
       * @param {Object} reqOptions
       * @returns {Promise<Object>} A promise to locations object as described in API documentation for `GET /api/locations/countries/<countryName>` endpoint
       */
      get: function get$1() {
        var country = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        var conditions = arguments.length > 2 ? arguments[2] : undefined;
        var reqOptions = arguments.length > 3 ? arguments[3] : undefined;
        var pathElements = Array.isArray(path) ? path : [path];
        var filterQuery = (conditions !== null && conditions !== void 0 ? conditions : []).filter(function (e) {
          return e;
        }).map(function (c) {
          return "filter=".concat(c);
        }).join('&');
        var uri = [COUNTRIES_URL, country].concat(toConsumableArray(pathElements)).filter(function (e) {
          return e;
        }).join('/');
        var query = [filterQuery].join('&');
        var url = [uri, query].filter(function (e) {
          return e;
        }).join('?');
        return get(url, reqOptions);
      }
    };
  };

  /**
   * Creates new Locations API client
   * @function
   * @param {string} baseApiUrl - base API url containing `/api` path, eg. `http://example.com/api`
   * @param {string} path - path storage API is available under, without leading slash, added to `baseApiUrl`. Defaults to `locations` when not defined.
   * @returns {LocationsAPI} new LocationsAPI object
   */
  var createLocationsAPI = function createLocationsAPI(baseApiUrl) {
    var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_API_PATH$3;
    var LOCATIONS_URL = "".concat(baseApiUrl, "/").concat(path);
    /**
     * Locations API client (`/api/locations/*` endpoints)
     * @typedef {Object} LocationsAPI
     * @property {Object} countries - functions of Countries module od LocationsAPI
     * @property {ServiceParametersAPI} params - functions for management of locations service parameters
     */
    return {
      LOCATIONS_URL: LOCATIONS_URL,
      /**
       * @memberof LocationsAPI
       */
      countries: createCountries(LOCATIONS_URL),
      /**
       * @memberof LocationsAPI
       */
      params: createParameters(LOCATIONS_URL)
    };
  };

  var DEFAULT_API_PATH$4 = 'register';
  var createRecords = function createRecords(registerApiUrl) {
    return {
      RECORDS_URL: "".concat(registerApiUrl, "/records"),
      /**
       * Gets content (list of records) of the given registry list
       * @memberof RegistryAPI.records
       * @param {string} listName - registry list name to get
       * @returns {Promise<Object[]>} A promise to list of records
       */
      list: function list(listName) {
        if (!listName) {
          throw new TypeError('invalid argument - listName must be defined');
        }
        return get("".concat(this.RECORDS_URL, "/").concat(listName));
      },
      /**
       * Adds new record to given list
       * @memberof RegistryAPI.records
       * @param {string} listName - registry list name record will be added to
       * @param {Object} record - registry list record to add
       * @returns {Promise} A promise to empty response
       */
      create: function create(listName, record) {
        return post("".concat(this.RECORDS_URL, "/").concat(listName), record);
      },
      /**
       * Removes record with given id from registry list with given name
       * @memberof RegistryAPI.records
       * @param {string} listName - registry list name record will be deleted from
       * @param {Object} recordId - id of the record to delete
       * @returns {Promise} A promise to empty response
       */
      delete: function _delete(listName, recordId) {
        return del("".concat(this.RECORDS_URL, "/").concat(listName, "/").concat(recordId));
      }
    };
  };

  /**
   * Creates new Register API client
   * @function
   * @param {string} baseApiUrl - base API url containing `/api` path, eg. `http://example.com/api`
   * @param {string} path - path storage API is available under, without leading slash, added to `baseApiUrl`. Defaults to `register` when not defined.
   * @returns {RegisterAPI} new RegisterAPI object
   */
  var createRegisterAPI = function createRegisterAPI(baseApiUrl) {
    var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_API_PATH$4;
    var REGISTER_URL = "".concat(baseApiUrl, "/").concat(path);
    /**
     * Register API client (`/api/register/*` endpoints)
     * @typedef {Object} RegisterAPI
     */
    return {
      /**
       * Gets description object for registry list with given name. If list name is omitted object describing all defined lists is returned.
       * @memberof RegisterAPI
       * @param {string} listName - name of the registry list to get
       * @returns {Object} object describing all defined regitry lists
       *
       */
      get: function get$1(listName) {
        return get("".concat(REGISTER_URL, "/lists").concat(listName ? "/".concat(listName) : ''));
      },
      /**
       * @memberof RegisterAPI
       */
      records: createRecords(REGISTER_URL)
    };
  };

  var DEFAULT_API_PATH$5 = 'services';

  /**
   * Creates new Services API client
   * @function
   * @param {string} baseApiUrl - base API url containing `/api` path, eg. `http://example.com/api`
   * @param {string} path - path storage API is available under, without leading slash, added to `baseApiUrl`. Defaults to `services` when not defined.
   * @returns {ServicesAPI} new ServicesAPI object
   */
  var createServicesAPI = function createServicesAPI(baseApiUrl) {
    var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_API_PATH$5;
    var SERVICES_URL = "".concat(baseApiUrl, "/").concat(path);
    /**
     * Services API client (`/api/services/*` endpoints)
     * @typedef {Object} ServicesAPI
     */
    return {
      /**
       * Gets URL to proxied service
       * @memberof ServicesAPI
       * @param {string} serviceName - name of the proxied service
       * @param {string[]} args - array of service arguments passed to request url
       * @returns {string} url to given service
       *
       */
      url: function url(serviceName, args) {
        if (!serviceName) {
          throw new TypeError('invalid argument - serviceName must be defined ');
        }
        var argStr = (args || []).filter(function (e) {
          return e;
        }).join('/');
        return "".concat(SERVICES_URL, "/").concat(serviceName).concat(argStr ? "/".concat(argStr) : '');
      }
    };
  };

  var DEFAULT_API_PATH$6 = 'storage';
  var createEvents = function createEvents(storageApiUrl) {
    return {
      EVENTS_URL: "".concat(storageApiUrl, "/events"),
      /**
       * Makes GET request to `/api/storage/events` endpoint
       * @memberof StorageAPI.events
       * @returns {Promise<string[]>} A promise to list of available event types (strings)
       * @example
       * storageAPI.events.types().then((result) => console.log(result.data))
       * // ['VehicleTrace', 'Status']
       */
      types: function types() {
        var result = null;
        result = get(this.EVENTS_URL);
        return result;
      },
      /**
       * Makes GET request to `/api/storage/events/<eventId>/<eventResourcePath>` endpoint
       * @memberof StorageAPI.events
       * @param {string} id - id of the event to get
       * @param {string} [resourcePath] - resource path
       * @returns {Promise<Object>} A promise to event object or event resource (if `resourcePath` param is provided)
       */
      get: function get$1(id, resourcePath) {
        var asDownload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var detailsUrl = "".concat(this.EVENTS_URL, "/").concat(id);
        var url = resourcePath ? "".concat(detailsUrl, "/").concat(resourcePath) : detailsUrl;
        return asDownload ? download(url, resourcePath) : get(url);
      },
      /**
       * Makes DELETE request to `/api/storage/events/<eventId>` endpoint
       * @memberof StorageAPI.events
       * @param {string} id - id of the event to delete
       * @returns {Promise<Object>} A promise of the event deletion
       */
      delete: function _delete(id) {
        var detailsUrl = "".concat(this.EVENTS_URL, "/").concat(id);
        return del(detailsUrl);
      },
      /**
       * Returns base event URL i.e. `http://example.com/api/storage/events/<eventId>`
       * @memberof StorageAPI.events
       * @param {string} id - id of the event URL is returned to
       * @returns {string} full event URL
       */
      baseUrl: function baseUrl(id) {
        return "".concat(this.EVENTS_URL, "/").concat(id);
      },
      /**
       * Returns URL to event's resource i.e. `http://example.com/api/storage/events/<eventId>/<resourcePath>`
       * @memberof StorageAPI.events
       * @param {string} id - id of the event URL is returned to
       * @param {string} resourceName - name of the resource URL is returned to
       * @returns {string} full event resource URL
       */
      resourceUrl: function resourceUrl(id, resourceName) {
        return "".concat(this.baseUrl(id), "/").concat(resourceName);
      }
    };
  };
  var createSearch = function createSearch(storageApiUrl) {
    return {
      SEARCH_URL: "".concat(storageApiUrl, "/search"),
      /**
       * Makes GET request to `/api/storage/search` endpoint
       * @memberof StorageAPI.search
       * @returns {Promise<SearchSchema>}
       */
      schema: function schema() {
        return get(this.SEARCH_URL);
      },
      /**
       * Performs search on event database. Makes GET request to `/api/storage/search/<EventType>?...` endpoint
       * @memberof StorageAPI.search
       * @param {string} type - type of the events to search
       * @param {string[]} [fields] - names of fields to return for each event
       * @param {string[]} [conditions]
       * @param {number} [from] - index of the first returned result (0-based)
       * @param {number} [count] - number of records to return
       * @param {string[]} [order]
       * @param {Object} [reqOptions]
       * @returns {Promise<string[]|Object[]>} if `fields` param is not defined returns array of event ids (strings) and array of objects otherwise.
       */
      results: function results(type, fields, conditions) {
        var from = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        var count = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 100;
        var order = arguments.length > 5 ? arguments[5] : undefined;
        var reqOptions = arguments.length > 6 ? arguments[6] : undefined;
        var conditionsPath = conditions && conditions.length > 0 ? conditions.map(function (c) {
          return encodeURIComponent(c);
        }).join('/') : null;
        var searchUrl = conditionsPath ? "".concat(this.SEARCH_URL, "/").concat(type, "/").concat(conditionsPath) : "".concat(this.SEARCH_URL, "/").concat(type);
        var queryString = ["from=".concat(from), "count=".concat(count), fields && fields.length > 0 ? "fields=".concat(fields.join(',')) : null, order && order.length > 0 ? "order=".concat(order.join(',')) : null].filter(function (e) {
          return e;
        }).join('&');
        return get(queryString ? "".concat(searchUrl, "?").concat(queryString) : searchUrl, reqOptions);
      }
    };
  };
  var createUnique = function createUnique(storageApiUrl) {
    return {
      UNIQUE_URL: "".concat(storageApiUrl, "/unique"),
      /**
       * Returns unique values from given field. Makes GET request to `/api/storage/unique/<EventType>/<field>` endpoint
       * @memberof StorageAPI.unique
       * @param {string} type - type of the events to search
       * @param {string} field - field name to extract unique values from
       * @returns {Promise<any[]>} - promise resolved with array of unique values which can be of any type
       */
      results: function results(type, field, reqOptions) {
        return get("".concat(this.UNIQUE_URL, "/").concat(type, "/").concat(field), reqOptions);
      }
    };
  };
  var createAggregate = function createAggregate(storageApiUrl) {
    return {
      AGGREGATE_URL: "".concat(storageApiUrl, "/aggregate"),
      /**
       * Returns aggregated value of the field. Makes GET request to `/api/storage/aggregate/<EventType>/<conditions>` endpoint
       * @memberof StorageAPI.aggregate
       * @param {string} type - type of the events to search
       * @param {string[]} [conditions] - search/filtering conditions; only matching records will be used by aggregation
       * @param {string} field - field/column name of which values are aggregated
       * @param {string} method - aggregation method; one of: avg, min, max, sum, concat, count
       * @param {string} group - field/column name result will be grouped by
       * @param {Object} [reqOptions]
       * @returns {Promise<any>} aggregated value of the given field - can be of any type, depending on aggregate method.
       */
      result: function result(type, conditions, field, method, group, reqOptions) {
        var conditionsPath = conditions && conditions.length > 0 ? conditions.map(function (c) {
          return encodeURIComponent(c);
        }).join('/') : null;
        var aggregateUrl = conditionsPath ? "".concat(this.AGGREGATE_URL, "/").concat(type, "/").concat(conditionsPath) : "".concat(this.AGGREGATE_URL, "/").concat(type);
        var queryString = "column=".concat(field, "&method=").concat(method);
        queryString = group ? "".concat(queryString, "&group=").concat(group) : queryString;
        return get("".concat(aggregateUrl, "?").concat(queryString), reqOptions);
      }
    };
  };
  var createReport = function createReport(storageApiUrl) {
    return {
      REPORT_URL: "".concat(storageApiUrl, "/report"),
      /**
       * Returns report for chosen event's type. Makes POST request to `/api/storage/report/<EventType>/<conditions>` endpoint
       * @memberof StorageAPI.report
       * @param {string} type - type of the events to report
       * @param {string[]} [conditions] - search/filtering conditions; only matching records will be used in report
       * @param {Object} reportSchema - report settings (format and columns to return)
       * @param {Object} [reqOptions]
       * @returns {Promise} report in one of formats: CSV, HTML, XLSX for chosen event's type
       */
      result: function result(type, conditions, reportSchema, reqOptions) {
        var conditionsPath = conditions && conditions.length > 0 ? conditions.map(function (c) {
          return encodeURIComponent(c);
        }).join('/') : null;
        var reportUrl = conditionsPath ? "".concat(this.REPORT_URL, "/").concat(type, "/").concat(conditionsPath) : "".concat(this.REPORT_URL, "/").concat(type);
        return post(reportUrl, reportSchema, reqOptions);
      }
    };
  };

  /**
   * Creates new Storage API client
   * @function
   * @param {string} baseApiUrl - base API url containing `/api` path, eg. `http://example.com/api`
   * @param {string} path - path storage API is available under, without leading slash, added to `baseApiUrl`. Defaults to `storage` when not defined.
   * @returns {StorageAPI} new StorageAPI object
   */
  var createStorageAPI = function createStorageAPI(baseApiUrl) {
    var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_API_PATH$6;
    var STORAGE_URL = "".concat(baseApiUrl, "/").concat(path);
    /**
     * Storage API client (`/api/storage/*` endpoints)
     * @typedef {Object} StorageAPI
     * @property {Object} events - functions of Events module of StorageAPI
     * @property {Object} search - functions of Search module of StorageAPI
     * @property {Object} unique - functions of Unique module of StorageAPI
     * @property {Object} aggregate - functions of Aggregate module of StorageAPI
     * @property {Object} report - functions of Report module of StorageAPI
     */
    return {
      /**
       * @memberof StorageAPI
       */
      events: createEvents(STORAGE_URL),
      /**
       * @memberof StorageAPI
       */
      search: createSearch(STORAGE_URL),
      /**
       * @memberof StorageAPI
       */
      unique: createUnique(STORAGE_URL),
      /**
       * @memberof StorageAPI
       */
      aggregate: createAggregate(STORAGE_URL),
      /**
       * @memberof StorageAPI
       */
      report: createReport(STORAGE_URL)
    };
  };

  /**
   * SearchSchema - object describing available search fields and their types.
   * This object has following shape:
   * ```js
   * {
   *   <EventType1>: {
   *     fieldName1: {SearchFieldType},
   *     fieldName2: {SearchFieldType},
   *     ...
   *   },
   *   <EventType2>: {...},
   * }
   * ```
   * @typedef SearchSchema
   * @type {Object}
   */

  /**
   * SearchFieldType - string describing type of given search field. It is one of the following values: 'TEXT', 'REAL', 'INTEGER'
   * @typedef SearchFieldType
   * @type {string}
   */

  /**
   * Events
   * @typedef Events
   * @type {(string[]|Object[])}
   */

  var DEFAULT_API_PATH$7 = 'terminals';
  var createItems$1 = function createItems(terminalsApiUrl) {
    var ITEMS_URL = "".concat(terminalsApiUrl, "/items");
    return {
      ITEMS_URL: ITEMS_URL,
      /**
       * Returns informations about terminals known to the system.
       * @memberof TerminalsAPI.items
       * @param {string[]} [fields] - names of fields to return for each terminal
       * @param {string[]} [conditions] - terminals filtering conditions in form ['field/name:operator:value',...]
       * @param {number} from - index of the first returned result (0-based)
       * @param {number} count - number of records to return
       * @param {Object} reqOptions
       * @returns {Promise<ListResponse>} if `fields` param is not defined returns array of event ids (strings) and array of objects otherwise.
       */
      list: function list(fields, conditions) {
        var from = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        var count = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 100;
        var reqOptions = arguments.length > 4 ? arguments[4] : undefined;
        var filterQuery = (conditions !== null && conditions !== void 0 ? conditions : []).filter(function (e) {
          return e;
        }).map(function (c) {
          return "filter=".concat(c);
        }).join('&');
        var queryString = ["from=".concat(from), "count=".concat(count), fields && fields.length > 0 ? "fields=".concat(fields.join(',')) : null, filterQuery !== null && filterQuery !== void 0 ? filterQuery : ''].filter(function (e) {
          return e;
        }).join('&');
        return get("".concat(ITEMS_URL).concat(queryString ? "?".concat(queryString) : ''), reqOptions);
      },
      /**
       * Returns object describing single terminal with given id
       * @memberof TerminalsAPI.items
       * @param {string} id - terminal id
       * @param {string|string[]} path - property path to extract from terminal object (eg. `time-info/zone`)
       * @param {Object} reqOptions
       * @returns {Promise<Object>} A promise to terminal object as described in API documentation for `GET /api/terminals/items/<terminalId>` endpoint
       */
      get: function get$1() {
        var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        var reqOptions = arguments.length > 2 ? arguments[2] : undefined;
        if (!id) {
          throw new Error('Terminal id is required');
        }
        var pathElements = Array.isArray(path) ? path : [path];
        var url = [ITEMS_URL, id].concat(toConsumableArray(pathElements)).filter(function (e) {
          return e;
        }).join('/');
        return get(url, reqOptions);
      }
    };
  };

  /**
   * Creates new Terminals API client
   * @function
   * @param {string} baseApiUrl - base API url containing `/api` path, eg. `http://example.com/api`
   * @param {string} path - path storage API is available under, without leading slash, added to `baseApiUrl`. Defaults to `terminals` when not defined.
   * @returns {TerminalsAPI} new TerminalsAPI object
   */
  var createTerminalsAPI = function createTerminalsAPI(baseApiUrl) {
    var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_API_PATH$7;
    var TERMINALS_URL = "".concat(baseApiUrl, "/").concat(path);
    /**
     * Terminals API client (`/api/terminals/*` endpoints)
     * @typedef {Object} TerminalsAPI
     * @property {Object} items - object with functions on Items module of TerminalsAPI
     * @property {ServiceParametersAPI} params - functions for management of terminals service parameters
     */
    return {
      TERMINALS_URL: TERMINALS_URL,
      /**
       * @memberof TerminalsAPI
       */
      items: createItems$1(TERMINALS_URL),
      /**
       * @memberof TerminalsAPI
       */
      params: createParameters(TERMINALS_URL)
    };
  };

  var SEPARATOR = ':';
  var StorageConditionsBuilder = /*#__PURE__*/function () {
    function StorageConditionsBuilder() {
      classCallCheck(this, StorageConditionsBuilder);
      this.timeRange = null;
      this.fieldConditions = null;
    }
    createClass(StorageConditionsBuilder, [{
      key: "fromTime",
      value: function fromTime(time) {
        this.timeRange = this.timeRange || {};
        this.timeRange.from = time;
        return this;
      }
    }, {
      key: "toTime",
      value: function toTime(time) {
        this.timeRange = this.timeRange || {};
        this.timeRange.to = time;
        return this;
      }
    }, {
      key: "addCondition",
      value: function addCondition(field, operator, params) {
        this.fieldConditions = this.fieldConditions || [];
        this.fieldConditions.push([field, operator, params]);
        return this;
      }
    }, {
      key: "lt",
      value: function lt(field, params) {
        return this.addCondition(field, 'lt', params);
      }
    }, {
      key: "gt",
      value: function gt(field, params) {
        return this.addCondition(field, 'gt', params);
      }
    }, {
      key: "le",
      value: function le(field, params) {
        return this.addCondition(field, 'le', params);
      }
    }, {
      key: "ge",
      value: function ge(field, params) {
        return this.addCondition(field, 'ge', params);
      }
    }, {
      key: "eq",
      value: function eq(field, params) {
        return this.addCondition(field, 'eq', params);
      }
    }, {
      key: "ne",
      value: function ne(field, params) {
        return this.addCondition(field, 'ne', params);
      }
    }, {
      key: "in",
      value: function _in(field, params) {
        return this.addCondition(field, 'in', params);
      }
    }, {
      key: "notin",
      value: function notin(field, params) {
        return this.addCondition(field, 'notin', params);
      }
    }, {
      key: "glob",
      value: function glob(field, params) {
        return this.addCondition(field, 'glob', params);
      }
    }, {
      key: "notglob",
      value: function notglob(field, params) {
        return this.addCondition(field, 'notglob', params);
      }
    }, {
      key: "regex",
      value: function regex(field, params) {
        return this.addCondition(field, 'regex', params);
      }
    }, {
      key: "noTimeRange",
      value: function noTimeRange() {
        this.timeRange = null;
        return this;
      }
    }, {
      key: "noField",
      value: function noField(field) {
        if (field && this.fieldConditions) {
          this.fieldConditions = this.fieldConditions.filter(function (c) {
            return c[0] !== field;
          });
          this.fieldConditions = null;
        }
        return this;
      }
    }, {
      key: "build",
      value: function build() {
        var conditions = [];
        var _ref = this.timeRange || {},
          from = _ref.from,
          to = _ref.to;
        if (from || to) {
          conditions.push("".concat(from || '', ",").concat(to || ''));
        }
        var fieldConditions = (this.fieldConditions || []).map(function (c) {
          return "".concat(c[0]).concat(SEPARATOR).concat(c[1]).concat(SEPARATOR).concat(c[2]);
        });
        return [].concat(conditions, toConsumableArray(fieldConditions));
      }
    }]);
    return StorageConditionsBuilder;
  }();

  function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
      var info = gen[key](arg);
      var value = info.value;
    } catch (error) {
      reject(error);
      return;
    }
    if (info.done) {
      resolve(value);
    } else {
      Promise.resolve(value).then(_next, _throw);
    }
  }
  function _asyncToGenerator(fn) {
    return function () {
      var self = this,
        args = arguments;
      return new Promise(function (resolve, reject) {
        var gen = fn.apply(self, args);
        function _next(value) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
        }
        function _throw(err) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
        }
        _next(undefined);
      });
    };
  }
  var asyncToGenerator = _asyncToGenerator;

  /* eslint-disable no-bitwise */

  function toUTF8Array(str) {
    var utf8 = [];
    for (var i = 0; i < str.length; i += 1) {
      var charcode = str.charCodeAt(i);
      if (charcode < 0x80) {
        utf8.push(charcode);
      } else if (charcode < 0x800) {
        utf8.push(0xc0 | charcode >> 6, 0x80 | charcode & 0x3f);
      } else if (charcode < 0xd800 || charcode >= 0xe000) {
        utf8.push(0xe0 | charcode >> 12, 0x80 | charcode >> 6 & 0x3f, 0x80 | charcode & 0x3f);
      }
      // surrogate pair
      else {
        i += 1;
        // UTF-16 encodes 0x10000-0x10FFFF by
        // subtracting 0x10000 and splitting the
        // 20 bits of 0x0-0xFFFFF into two halves
        charcode = 0x10000 + ((charcode & 0x3ff) << 10 | str.charCodeAt(i) & 0x3ff);
        utf8.push(0xf0 | charcode >> 18, 0x80 | charcode >> 12 & 0x3f, 0x80 | charcode >> 6 & 0x3f, 0x80 | charcode & 0x3f);
      }
    }
    return utf8;
  }

  var JTK = function MessageFactory() {
    // 'private' members
    var DEFAULT_SEPARATOR = '.';

    // constructonr function
    function JSONToolkit(separator) {
      this.separator = separator || DEFAULT_SEPARATOR;
    }
    JSONToolkit.prototype.get = function get(propertyName, object) {
      var separator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.separator;
      var parts = propertyName.split(separator);
      var property = object || this;
      for (var i = 0; i < parts.length; i += 1) {
        var newValue = property[parts[i]];
        if (newValue === null || newValue === undefined) {
          return newValue;
        }
        property = newValue;
      }
      return property;
    };
    JSONToolkit.prototype.setSeparator = function setSeparator(separator) {
      this.separator = separator || DEFAULT_SEPARATOR;
    };
    return new JSONToolkit();
  }();

  function _regeneratorRuntime() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof_1(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

  /**
   * SHA256 calculation based on SubtleCrypto WebAPI
   *
   * @param data {ArrayBuffer | ArrayBufferView | string}
   */

  var sha256wa = /*#__PURE__*/function () {
    var _ref = asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(data) {
      var isArrayBuffer, buffer, encoder, hashBuffer, hashArray, hashHex;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              isArrayBuffer = data && (data instanceof ArrayBuffer || data.buffer instanceof ArrayBuffer) && data.byteLength !== undefined;
              buffer = data;
              if (!(typeof data === 'string')) {
                _context.next = 7;
                break;
              }
              encoder = new TextEncoder();
              buffer = encoder.encode(data);
              _context.next = 9;
              break;
            case 7:
              if (isArrayBuffer) {
                _context.next = 9;
                break;
              }
              throw new Error("Invalid data type. Please provide either ArrayBuffer, ArrayBufferView or string");
            case 9:
              _context.next = 11;
              return crypto.subtle.digest('SHA-256', buffer);
            case 11:
              hashBuffer = _context.sent;
              hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
              hashHex = hashArray.map(function (b) {
                return b.toString(16).padStart(2, '0');
              }).join('');
              return _context.abrupt("return", hashHex);
            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function sha256wa(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var MIMETYPE = {
    IMAGE_BMP: 'image/bmp',
    IMAGE_JPEG: 'image/jpeg',
    IMAGE_PNG: 'image/png',
    IMAGE_GIF: 'image/gif',
    IMAGE_SVG: 'image/svg+xml',
    IMAGE_TIFF: 'image/tiff',
    IMAGE_WEBP: 'image/webp',
    TEXT_PLAIN: 'text/plain',
    TEXT_HTML: 'text/html',
    TEXT_CSV: 'text/csv',
    APPLICATION_JSON: 'application/json',
    APPLICATION_PDF: 'application/pdf',
    APPLICATION_RDF: 'application/rtf',
    APPLICATION_XML: 'application/xml',
    APPLICATION_XHTML: 'application/xhtml+xml',
    APPLICATION_ZIP: 'application/zip',
    APPLICATION_7Z: 'application/x-7z-compressed',
    APPLICATION_TAR: 'application/x-tar',
    APPLICATION_GZIP: 'application/gzip',
    APPLICATION_RAR: 'application/vnd.rar',
    APPLICATION_OGG: 'application/ogg',
    APPLICATION_BZIP: 'application/x-bzip',
    APPLICATION_BZIP2: 'application/x-bzip2',
    APPLICATION_OCTETSTREAM: 'application/octet-stream',
    AUDIO_AAC: 'audio/aac',
    AUDIO_MPEG: 'audio/mpeg',
    AUDIO_OGG: 'audio/ogg',
    AUDIO_WEBM: 'audio/webm',
    AUDIO_WAV: 'audio/wav',
    VIDEO_AVI: 'video/x-msvideo',
    VIDEO_MP4: 'video/mp4',
    VIDEO_MPEG: 'video/mpeg',
    VIDEO_OGG: 'video/ogg',
    VIDEO_WEBM: 'video/webm',
    VIDEO_MP2T: 'video/mp2t'
  };
  var EXT_MIME_MAP = {
    // images
    bmp: MIMETYPE.IMAGE_BMP,
    jpg: MIMETYPE.IMAGE_JPEG,
    jpeg: MIMETYPE.IMAGE_JPEG,
    jpe: MIMETYPE.IMAGE_JPEG,
    gif: MIMETYPE.IMAGE_GIF,
    svg: MIMETYPE.IMAGE_SVG,
    png: MIMETYPE.IMAGE_PNG,
    tif: MIMETYPE.IMAGE_TIFF,
    tiff: MIMETYPE.IMAGE_TIFF,
    webp: MIMETYPE.IMAGE_WEBP,
    // audio
    aac: MIMETYPE.AUDIO_AAC,
    mp3: MIMETYPE.AUDIO_MPEG,
    oga: MIMETYPE.AUDIO_OGG,
    weba: MIMETYPE.AUDIO_WEBM,
    wav: MIMETYPE.AUDIO_WAV,
    // video
    avi: MIMETYPE.VIDEO_AVI,
    mpeg: MIMETYPE.VIDEO_MPEG,
    mp4: MIMETYPE.VIDEO_MP4,
    ogv: MIMETYPE.VIDEO_OGG,
    webm: MIMETYPE.VIDEO_WEBM,
    ts: MIMETYPE.VIDEO_MP2T,
    ogx: MIMETYPE.APPLICATION_OGG,
    // text / documents
    txt: MIMETYPE.TEXT_PLAIN,
    csv: MIMETYPE.TEXT_CSV,
    htm: MIMETYPE.TEXT_HTML,
    html: MIMETYPE.TEXT_HTML,
    xhtml: MIMETYPE.APPLICATION_XHTML,
    json: MIMETYPE.APPLICATION_JSON,
    xml: MIMETYPE.APPLICATION_XML,
    pdf: MIMETYPE.APPLICATION_PDF,
    // archives
    zip: MIMETYPE.APPLICATION_ZIP,
    '7z': MIMETYPE.APPLICATION_7Z,
    tar: MIMETYPE.APPLICATION_TAR,
    gz: MIMETYPE.APPLICATION_GZIP,
    rar: MIMETYPE.APPLICATION_RAR,
    bz: MIMETYPE.APPLICATION_BZIP,
    bz2: MIMETYPE.APPLICATION_BZIP2,
    // binary
    bin: MIMETYPE.APPLICATION_OCTETSTREAM
  };
  var guessMimeType = function guessMimeType(filename) {
    var _filename$substring;
    var extension = filename === null || filename === void 0 ? void 0 : (_filename$substring = filename.substring((filename === null || filename === void 0 ? void 0 : filename.lastIndexOf('.')) + 1)) === null || _filename$substring === void 0 ? void 0 : _filename$substring.toLowerCase();
    return EXT_MIME_MAP[extension] || MIMETYPE.APPLICATION_OCTETSTREAM;
  };

  /*
   * tar-js
   * MIT (c) 2011 T. Jameson Little
   */

  var utils = function utils() {
    var lookup = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '+', '/'];
    function clean(length) {
      var i;
      var buffer = new Uint8Array(length);
      for (i = 0; i < length; i += 1) {
        buffer[i] = 0;
      }
      return buffer;
    }
    function extend(orig, length, addLength, multipleOf) {
      var newSize = length + addLength;
      var buffer = clean((parseInt(newSize / multipleOf) + 1) * multipleOf);
      buffer.set(orig);
      return buffer;
    }
    function pad(num, bytes, base) {
      num = num.toString(base || 8);
      return '000000000000'.substr(num.length + 12 - bytes) + num;
    }
    function stringToUint8(input, out, offset) {
      var i;
      var length;
      out = out || clean(input.length);
      offset = offset || 0;
      for (i = 0, length = input.length; i < length; i += 1) {
        out[offset] = input.charCodeAt(i);
        offset += 1;
      }
      return out;
    }
    function uint8ToBase64(uint8) {
      var i;
      var extraBytes = uint8.length % 3; // if we have 1 byte left, pad 2 bytes
      var output = '';
      var temp;
      var length;
      function tripletToBase64(num) {
        return lookup[num >> 18 & 0x3f] + lookup[num >> 12 & 0x3f] + lookup[num >> 6 & 0x3f] + lookup[num & 0x3f];
      }

      // go through the array every three bytes, we'll deal with trailing stuff later
      for (i = 0, length = uint8.length - extraBytes; i < length; i += 3) {
        temp = (uint8[i] << 16) + (uint8[i + 1] << 8) + uint8[i + 2];
        output += tripletToBase64(temp);
      }

      // this prevents an ERR_INVALID_URL in Chrome (Firefox okay)
      switch (output.length % 4) {
        case 1:
          output += '=';
          break;
        case 2:
          output += '==';
          break;
      }
      return output;
    }

    // module.exports.clean = clean;
    // module.exports.pad = pad;
    // module.exports.extend = extend;
    // module.exports.stringToUint8 = stringToUint8;
    // module.exports.uint8ToBase64 = uint8ToBase64;

    return {
      clean: clean,
      pad: pad,
      extend: extend,
      stringToUint8: stringToUint8,
      uint8ToBase64: uint8ToBase64
    };
  }();

  /*
   * tar-js
   * MIT (c) 2011 T. Jameson Little
   */
  var header = function header() {
    /*
    struct posix_header {             // byte offset
    char name[100];               //   0
    char mode[8];                 // 100
    char uid[8];                  // 108
    char gid[8];                  // 116
    char size[12];                // 124
    char mtime[12];               // 136
    char chksum[8];               // 148
    char typeflag;                // 156
    char linkname[100];           // 157
    char magic[6];                // 257
    char version[2];              // 263
    char uname[32];               // 265
    char gname[32];               // 297
    char devmajor[8];             // 329
    char devminor[8];             // 337
    char prefix[155];             // 345
                                    // 500
    };
    */

    // const utils = require('./utils');

    var headerFormat = [{
      field: 'fileName',
      length: 100
    }, {
      field: 'fileMode',
      length: 8
    }, {
      field: 'uid',
      length: 8
    }, {
      field: 'gid',
      length: 8
    }, {
      field: 'fileSize',
      length: 12
    }, {
      field: 'mtime',
      length: 12
    }, {
      field: 'checksum',
      length: 8
    }, {
      field: 'type',
      length: 1
    }, {
      field: 'linkName',
      length: 100
    }, {
      field: 'ustar',
      length: 8
    }, {
      field: 'owner',
      length: 32
    }, {
      field: 'group',
      length: 32
    }, {
      field: 'majorNumber',
      length: 8
    }, {
      field: 'minorNumber',
      length: 8
    }, {
      field: 'filenamePrefix',
      length: 155
    }, {
      field: 'padding',
      length: 12
    }];
    function formatHeader(data, cb) {
      var buffer = utils.clean(512);
      var offset = 0;
      headerFormat.forEach(function (value) {
        var str = data[value.field] || '';
        var i;
        var length = str.length;
        for (i = 0; i < length; i += 1) {
          buffer[offset] = str.charCodeAt(i);
          offset += 1;
        }
        offset += value.length - i; // space it out with nulls
      });

      if (typeof cb === 'function') {
        return cb(buffer, offset);
      }
      return buffer;
    }

    // module.exports.structure = headerFormat;
    // module.exports.format = formatHeader;
    return {
      structure: headerFormat,
      format: formatHeader
    };
  }();

  /*
   * tar-js
   * MIT (c) 2011 T. Jameson Little
   */
  var tar = function tar() {
    // const header = require('./header');
    // const utils = require('./utils');
    var recordSize = 512;
    var blockSize;
    function Tar(recordsPerBlock) {
      this.written = 0;
      blockSize = (recordsPerBlock || 20) * recordSize;
      this.out = utils.clean(blockSize);
    }
    Tar.prototype.append = function append(filepath, input, opts, callback) {
      var data;
      var checksum;
      var mode;
      var mtime;
      var uid;
      var gid;
      var headerArr;
      if (typeof input === 'string') {
        input = utils.stringToUint8(input);
      } else if (input.constructor !== Uint8Array.prototype.constructor) {
        throw new Error("Invalid input type. You gave me: ".concat(input.constructor.toString().match(/function\s*([$A-Za-z_][0-9A-Za-z_]*)\s*\(/)[1]));
      }
      if (typeof opts === 'function') {
        callback = opts;
        opts = {};
      }
      opts = opts || {};
      mode = opts.mode || 511 & 0xfff; // eslint-disable-line no-bitwise
      mtime = opts.mtime || Math.floor(+new Date() / 1000);
      uid = opts.uid || 0;
      gid = opts.gid || 0;
      data = {
        fileName: filepath,
        fileMode: utils.pad(mode, 7),
        uid: utils.pad(uid, 7),
        gid: utils.pad(gid, 7),
        fileSize: utils.pad(input.length, 11),
        mtime: utils.pad(mtime, 11),
        checksum: '        ',
        type: '0',
        // just a file
        ustar: 'ustar  ',
        owner: opts.owner || '',
        group: opts.group || ''
      };

      // calculate the checksum
      checksum = 0;
      Object.keys(data).forEach(function (key) {
        var i;
        var value = data[key];
        var length = value.length;
        for (i = 0; i < length; i += 1) {
          checksum += value.charCodeAt(i);
        }
      });
      data.checksum = "".concat(utils.pad(checksum, 6), "\0 ");
      headerArr = header.format(data);
      this.out.set(headerArr, this.written);
      this.written += headerArr.length;

      // If there is not enough space in this.out, we need to expand it to
      // fit the new input.
      if (this.written + input.length > this.out.length) {
        this.out = utils.extend(this.out, this.written, input.length, blockSize);
      }
      this.out.set(input, this.written);

      // to the nearest multiple of recordSize
      this.written += input.length + (recordSize - (input.length % recordSize || recordSize));

      // make sure there's at least 2 empty records worth of extra space
      if (this.out.length - this.written < recordSize * 2) {
        this.out = utils.extend(this.out, this.written, recordSize * 2, blockSize);
      }
      if (typeof callback === 'function') {
        callback(this.out);
      }
      return this.out;
    };
    Tar.prototype.clear = function () {
      this.written = 0;
      this.out = utils.clean(blockSize);
    };
    return Tar;
    // module.exports = Tar;
  }();

  function _regeneratorRuntime$1() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime$1 = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof_1(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
  function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
  function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) { defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var pad = function pad(num, size) {
    return Number.isInteger(num) ? num.toString().padStart(size, '0') : num;
  };
  var formatTime = function formatTime(timestamp) {
    var dt = new Date(timestamp);
    var date = "".concat(dt.getUTCFullYear(), "-").concat(pad(dt.getUTCMonth() + 1, 2), "-").concat(pad(dt.getUTCDate(), 2));
    var time = "".concat(pad(dt.getUTCHours(), 2), ":").concat(pad(dt.getUTCMinutes(), 2), ":").concat(pad(dt.getUTCSeconds(), 2), ".").concat(pad(dt.getUTCMilliseconds(), 3));
    return "".concat(date, "T").concat(time, "Z");
  };
  var MessageFactory = function () {
    /**
     * MessageFactory
     * @typedef {Object} MessageFactory
     * @property {function} create - creates empty Message based on some basic values
     * @property {function} createFromIndex - creates Message from existing index JSON
     */

    // proper Message
    var Message = function Message(initialIndex) {
      // constants
      var DEFAULT_RESOURCE_KIND = 'anything';
      var RESERVED_FILENAMES = ['index.json'];
      var RESERVED_METADATA_KEYS = ['checksum', 'size', 'kind', 'mimetype'];
      var REQUIRED_KEYS = {
        time: /[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}\.[0-9]{3}Z/,
        type: /^[a-zA-Z]{3,}$/,
        id: /^[a-zA-Z]{3,}-[0-9]{8}-[0-9]{6}-[0-9]{3}(?:-[a-z0-9-]+)?$/,
        version: /[0-9]\.[0-9]/
      };
      // message internal fields
      var index = {};
      var resources = {};
      var serialized = {
        data: null,
        hash: null
      };
      // message methods
      var checkJson = function checkJson(json) {
        var missingRequirements = Object.keys(REQUIRED_KEYS).reduce(function (mr, path) {
          var property = JTK.get(path, json);
          var formatRegex = REQUIRED_KEYS[path];
          if (property && !formatRegex.test(property)) {
            throw new Error("Bad format of required field ".concat(path, " in JSON: ").concat(property));
          }
          return property ? mr : [].concat(toConsumableArray(mr), [path]);
        }, []);
        if (missingRequirements.length > 0) {
          throw new Error("Lack of required keys in JSON object: ".concat(missingRequirements.join(', ')));
        }
      };
      var hasResource = function hasResource(name) {
        var _index, _index$resources;
        return !!((_index = index) !== null && _index !== void 0 && (_index$resources = _index.resources) !== null && _index$resources !== void 0 && _index$resources[name]);
      };
      var getResourceMetadata = function getResourceMetadata(name, withoutReserved) {
        var _index2, _index2$resources;
        if (!hasResource(name)) {
          throw new Error("This Message doesn't have resource named ".concat(name));
        }
        var metadata = (_index2 = index) === null || _index2 === void 0 ? void 0 : (_index2$resources = _index2.resources) === null || _index2$resources === void 0 ? void 0 : _index2$resources[name];
        if (withoutReserved) {
          metadata = Object.keys(metadata).reduce(function (res, key) {
            return RESERVED_METADATA_KEYS.includes(key) ? res : _objectSpread$2(_objectSpread$2({}, res), {}, defineProperty({}, key, metadata[key]));
          }, {});
        }
        return metadata;
      };

      /**
       *
       * @param {string} fileName - name of the file containing resource
       * @param {Uint8Array|string} content - binary content of the file resource, array of bytes or string (must have length property)
       * @param {string} kind - resource kind
       * @param {object} metadata - additional metadata - values under reserved keys (like kind, checksum, size, mimetype) will be ignored
       * @param {boolean} override - override resource with the same name (true) or not (false)
       */
      var putResource = /*#__PURE__*/function () {
        var _ref = asyncToGenerator( /*#__PURE__*/_regeneratorRuntime$1().mark(function _callee(fileName, content, kind, metadata) {
          var override,
            digest,
            checksum,
            mimetype,
            resource,
            _args = arguments;
          return _regeneratorRuntime$1().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  override = _args.length > 4 && _args[4] !== undefined ? _args[4] : false;
                  if (!RESERVED_FILENAMES.includes(fileName)) {
                    _context.next = 3;
                    break;
                  }
                  throw new Error("File name ".concat(fileName, " is reserved and can't be added as resource"));
                case 3:
                  if (!(Object.keys(index.resources).includes(fileName) && !override)) {
                    _context.next = 5;
                    break;
                  }
                  throw new Error("Resource ".concat(fileName, " already exists"));
                case 5:
                  _context.next = 7;
                  return sha256wa(content);
                case 7:
                  digest = _context.sent;
                  checksum = "{SHA256}".concat(digest); // console.log('Message Content: ', typeof content, checksum, content.length);
                  mimetype = guessMimeType(fileName);
                  resource = Object.keys(metadata || {}).reduce(function (res, key) {
                    return RESERVED_METADATA_KEYS.includes(key) ? res : _objectSpread$2(_objectSpread$2({}, res), {}, defineProperty({}, key, metadata[key]));
                  }, {
                    kind: kind || DEFAULT_RESOURCE_KIND,
                    checksum: checksum,
                    size: (content === null || content === void 0 ? void 0 : content.length) || -1,
                    mimetype: mimetype
                  });
                  index.resources = _objectSpread$2(_objectSpread$2({}, index.resources || {}), {}, defineProperty({}, fileName, resource));
                  resources = _objectSpread$2(_objectSpread$2({}, resources), {}, defineProperty({}, fileName, content));
                case 13:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));
        return function putResource(_x, _x2, _x3, _x4) {
          return _ref.apply(this, arguments);
        };
      }();

      // TODO add possibility to add nested paths - for now only root level is supported
      var put = function put(path, value) {
        var it = index;
        var splitPath = path.split('/');
        splitPath.slice(0, -1).forEach(function (key) {
          if (!Object.keys(it).includes(key)) {
            it[key] = {};
          }
          it = it[key];
        });
        it[splitPath[splitPath.length - 1]] = value;
      };
      var setStatus = function setStatus(status) {
        var timestamp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Date.now();
        index.status = {
          name: status,
          time: formatTime(timestamp)
        };
      };
      var setStatusNew = function setStatusNew(timestamp) {
        setStatus('new', timestamp);
      };
      var setStatusUpdated = function setStatusUpdated(timestamp) {
        setStatus('updated', timestamp);
      };

      // Message serialization
      var serialize = /*#__PURE__*/function () {
        var _ref2 = asyncToGenerator( /*#__PURE__*/_regeneratorRuntime$1().mark(function _callee2(cb) {
          var indexString, indexHash, indexBytes, tarball;
          return _regeneratorRuntime$1().wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  indexString = JSON.stringify(index);
                  _context2.next = 3;
                  return sha256wa(indexString);
                case 3:
                  indexHash = _context2.sent;
                  if (!(serialized.hash === indexHash && serialized.data !== null)) {
                    _context2.next = 6;
                    break;
                  }
                  return _context2.abrupt("return", serialized.data);
                case 6:
                  indexBytes = toUTF8Array(indexString);
                  tarball = new tar(2); // 2 records per 512b block, 1kB initial size - no need for any more, especially 20
                  tarball.append('index.json', new Uint8Array(indexBytes), null, cb);
                  Object.keys(resources).forEach(function (fname) {
                    tarball.append(fname, resources[fname], null);
                  });
                  serialized.hash = indexHash;
                  serialized.data = tarball.out;
                  return _context2.abrupt("return", serialized.data);
                case 13:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));
        return function serialize(_x5) {
          return _ref2.apply(this, arguments);
        };
      }();
      var sendTo = /*#__PURE__*/function () {
        var _ref3 = asyncToGenerator( /*#__PURE__*/_regeneratorRuntime$1().mark(function _callee3(url) {
          var headers;
          return _regeneratorRuntime$1().wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  headers = {
                    'Content-Type': 'application/x-tar',
                    'Content-Disposition': "attachment; filename=".concat(index.id, ".tar"),
                    'X-Requested-With': 'XMLHttpRequest'
                  };
                  _context3.t0 = fetch;
                  _context3.t1 = url;
                  _context3.t2 = headers;
                  _context3.next = 6;
                  return serialize();
                case 6:
                  _context3.t3 = _context3.sent;
                  _context3.t4 = {
                    method: 'POST',
                    headers: _context3.t2,
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    body: _context3.t3
                  };
                  return _context3.abrupt("return", (0, _context3.t0)(_context3.t1, _context3.t4));
                case 9:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));
        return function sendTo(_x6) {
          return _ref3.apply(this, arguments);
        };
      }();

      // execute
      checkJson(initialIndex);
      index = initialIndex;
      return {
        getIndex: function getIndex() {
          return index;
        },
        getId: function getId() {
          var _index3;
          return (_index3 = index) === null || _index3 === void 0 ? void 0 : _index3.id;
        },
        put: put,
        putResource: putResource,
        getResourceMetadata: getResourceMetadata,
        setStatus: setStatus,
        setStatusNew: setStatusNew,
        setStatusUpdated: setStatusUpdated,
        sendTo: sendTo
      };
    };

    // factory functions
    var buildId = function buildId(type, timestamp, suffix) {
      var time = formatTime(timestamp).replace(/[-:Z]/g, '').replace(/[T.]/g, '-');
      return suffix ? "".concat(type, "-").concat(time, "-").concat(suffix) : "".concat(type, "-").concat(time);
    };

    /**
     * Creates empty message from provided basic values
     * @memberof MessageFactory
     * @param {string} type message type written in CamelCase eg. VehicleTrace, Status, AccessRequest etc.
     * @param {number|string} timestamp UTC time of the message - any value understood by JS Date constructor. Defaults to current time if not provided.
     * @param {string} suffix suffix to be appended to message id
     * @returns {Object} A new message object
     * @example
     * import { MessageFactory } from '@nrspl/js-api-client'
     * ...
     * const message = MessageFactory.create('SampleMessage', '2020-08-03T11:36:28.123Z', 'sampleSuffix');
     * ...
     */
    var create = function create() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'PlaceHolder';
      var timestamp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Date.now();
      var suffix = arguments.length > 2 ? arguments[2] : undefined;
      var index = {
        type: type,
        version: '4.2',
        time: formatTime(timestamp),
        id: buildId(type, timestamp, suffix),
        resources: {}
      };
      return Message(index);
    };

    /**
     * Creates Message based on existing index.json object
     * @memberof MessageFactory
     * @param {Object} indexObject index object used for initialization
     * @param {bool} clearResourcesMetadata if set to true, resources property of provided index object will be replaced with empty object {}
     * @returns {Object} A new message object
     * @example
     * import { MessageFactory } from '@nrspl/js-api-client'
     * ...
     * const index = {
     *   id: "SampleMessage-20200803-113628-123",
     *   type: "SampleMessage",
     *   version: "4.2",
     *   time: "2020-08-03T11:36:28.123Z",
     *   ...
     * }
     * const message = MessageFactory.createFromIndex(index);
     * ...
     */
    var createFromIndex = function createFromIndex(indexObject) {
      var clearResourcesMetadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var idx = indexObject;
      if (!indexObject.resources || clearResourcesMetadata) {
        idx = _objectSpread$2(_objectSpread$2({}, indexObject), {}, {
          resources: {}
        });
      }
      return Message(idx);
    };
    return {
      create: create,
      createFromIndex: createFromIndex
    };
  }();

  exports.CONTENT_TYPE = CONTENT_TYPE;
  exports.MessageFactory = MessageFactory;
  exports.StorageConditionsBuilder = StorageConditionsBuilder;
  exports.createAccessAPI = createAccessAPI;
  exports.createConfigAPI = createConfigAPI;
  exports.createDronesAPI = createDronesAPI;
  exports.createGeneralAPI = createGeneralAPI;
  exports.createLocationsAPI = createLocationsAPI;
  exports.createParameters = createParameters;
  exports.createRegisterAPI = createRegisterAPI;
  exports.createServicesAPI = createServicesAPI;
  exports.createStorageAPI = createStorageAPI;
  exports.createTerminalsAPI = createTerminalsAPI;
  exports.del = del;
  exports.download = download;
  exports.get = get;
  exports.post = post;
  exports.put = put;
  exports.request = request;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
